export default __webpack_public_path__ + "img/WB_RTK_250MA_BF.02e42450102da1aa252f1c8192bcd749.jpg";